import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing }) => ({
  arrowIcon: {
    transform: 'rotate(90deg)',
    transformOrigin: '50% 50%'
  },
  icon: {
    marginRight: spacing(2)
  }
}));
